/**
 * 图表卡片中 展示对比时间的图标
 * 用于拖拉拽页面和报表页面
 */
import React, { useState } from "react";
import { useIntl } from "umi";
import { isEmpty } from "lodash-es";
import classNames from "classnames";
import { Dropdown, Bubble, BubbleProps, PopoverProps, DropdownProps } from "tea-component";
import SvgIcon from "@home/components/SvgIcon";
import TimeCompare from "@/pages/datalab/components/DateComponents/TimeCompare";
import { ITimeCompareProps } from "@/pages/datalab/components/DateComponents/TimeCompare/types";
import { formatDateRange, getDateRange } from "@dbl/core/date";
import { TRelativeTime } from "@dbl/core/date";

interface IVsIconProps extends Omit<ITimeCompareProps, 'onCancel' | 'onStateChange'> {
  className?: string;
  style?: React.CSSProperties;
  popoverProps?: PopoverProps;
  bubbleProps?: BubbleProps;
  dropdownProps?: DropdownProps;
  active?: boolean;
  disabled?: boolean;
  onCancel?: () => void;
  onStateChange?: () => void;
  // 是否显示 单选
  openSingle?: boolean;
  // 是否显示baseTime 文本
  showBaseTime?: boolean;
  /** 与图标同一触发区（如预览「更多」菜单内）：文案可点、悬停与图标一致 */
  triggerLabel?: React.ReactNode;
}

const VsIcon: React.FC<IVsIconProps> = (props) => {
  const { className, style, bubbleProps, dropdownProps, popoverProps, active, disabled, onConfirm, triggerLabel, ...rest} = props;
  const { formatMessage } = useIntl();
  // 为了更新 Dropdown下拉框弹窗的位置, 设置的状态
  // 对比时间下拉框的内容会跟随用户操作, 导致宽度变大变小, 导致显示位置和图标位置差距太大
  const [refresh, setRefresh] = useState<number>(0);
  
  return (<Bubble dark content={formatMessage({id: 'dbl_time_compare_title'})} {...(bubbleProps || {})} >
    <Dropdown
      clickClose={false}
      disabled={disabled}
      updateDeps={[refresh]}
      boxClassName={'dbl-card-drag-operation-dropdown'}
      /* 不能被图表的浮窗遮盖 */
      overlayStyle={{zIndex: 99999999}}
      className={className}
      style={style}
      button={
        triggerLabel ? (
          <span
            className={classNames(
              'dbl-card-preview-menu-inline-trigger',
              active && 'dbl-card-preview-menu-inline-trigger--active',
              disabled && 'dbl-card-preview-menu-inline-trigger--disabled',
            )}
          >
            <SvgIcon
              className="table-analysis-icon"
              style={{
                color: active ? '#326FF0' : 'unset',
                cursor: disabled ? 'not-allowed' : 'pointer',
              }}
              type="vs-icon"
            />
            {triggerLabel}
          </span>
        ) : (
          <SvgIcon
            className="table-analysis-icon"
            style={{
              color: active ? '#326FF0' : 'unset',
              cursor: disabled ? 'not-allowed' : 'pointer',
            }}
            type="vs-icon"
          />
        )
      }
      appearance="pure"
      placement="bottom-end"
      {...dropdownProps}
    >
      {
        (close) => (<TimeCompare
          {...rest}
          dropdownProps={dropdownProps}
          popoverProps={popoverProps}
          onConfirm={(compareTimes) => {
            let newCompareTimes: TRelativeTime[] = [];
            if (compareTimes && compareTimes.length > 0) {
              newCompareTimes = compareTimes.map((compare) => {
                if (compare?.time_range && isEmpty(compare.last_time)) return compare;
                const {last_time, granularity} = compare || {};
                const range = getDateRange(rest?.baseTimeRange || [], {amount: last_time, granularity, timeGranularity: rest?.timeGranularity});
                return {
                  ...compare,
                  time_range: formatDateRange(range, rest?.timeGranularity),
                };
              });
            }
            onConfirm?.(newCompareTimes);
            close?.();
          }}
          onCancel={close}
          onStateChange={() => {
            setRefresh(refresh + 1);
          }}
        />)
      }
    </Dropdown></Bubble>);
};

export default VsIcon;